import '../styles/App.css';

import React from 'react';
import { styled } from '@mui/material/styles';
import Grid from '@mui/material/Grid';
import Slider from '@mui/material/Slider';
import Input from '@mui/material/Input';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import InfoIcon from './SVGCollection'

const StyledMenuItem = styled(MenuItem)({
  color: 'rgba(255, 255, 255, 0.8)',
  backgroundColor: 'transparent',
  fontFamily: 'Menco, Open Sans, sans-serif',
  fontSize: '12px',
  textTransform: 'uppercase',
  letterSpacing: '0.5px',
  padding: '8px 16px',
  transition: 'background 0.2s ease',
  '&:hover': {
    backgroundColor: 'rgba(255, 255, 255, 0.08)',
  },
  '&.Mui-selected': {
    background: 'linear-gradient(.25turn, #00C4ED, #00E880)',
    color: '#ffffff',
    '&:hover': {
      background: 'linear-gradient(.25turn, #00D4F7, #00F890)',
    },
  },
});

const CustomSlider = styled(Slider)({
  '& .MuiSlider-rail': {
    backgroundImage: "linear-gradient(.25turn, #00C4ED, #00E880)",
    height: 3,
  },
  '& .MuiSlider-track': {
    backgroundImage: "linear-gradient(.25turn, #00C4ED, #00E880)",
    height: 3,
  },
  '& .MuiSlider-thumb': {
    backgroundImage: "linear-gradient(.25turn, #00C4ED, #00E880)",
    width: 16,
    height: 16,
    '&:hover': {
      boxShadow: '0 0 0 8px rgba(0, 196, 237, 0.16)',
    },
  }
});

export default function InputDropDown(props) {
  const min = props.values[0]
  const max = props.values[props.values.length-1]
  const selectRef = React.useRef(null);

  const [value, setValue] = React.useState(props.startValue);

  const handleInputChange = (event) => {
    setValue(event.target.value === '' ? '' : Number(event.target.value));
    props.handleClick(event.target.value, props.name)
  }

  var dropdownOptions = []
  for (var i = 0; i < props.values.length; i++) {
    // this.gradient(percentage).toString()
    dropdownOptions.push(
      <StyledMenuItem key={props.labels[i]} value={props.values[i]} >{props.labels[i]}</StyledMenuItem>
    )
  }

  // var input = <FormControl sx={{ m: 1, width: 500, height: 500 }}>
  //         <Select
  //           style={{color: 'white', fontWeight: '300'}}
  //           value={value}
  //           onChange={handleInputChange}
  //           displayEmpty
  //           inputProps={{ 'aria-label': 'Without label' }}
  //         >
  //         {dropdownOptions}
  //       </Select>
  //     </FormControl> 

  var input = <FormControl sx={{ 
    minWidth: 120, 
    maxWidth: '100%', 
    flexShrink: 1,
    '& .MuiOutlinedInput-root': {
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        border: 'none', // Remove focus outline
      },
      '&:hover .MuiOutlinedInput-notchedOutline': {
        border: 'none', // Remove hover outline
      },
      '& .MuiOutlinedInput-notchedOutline': {
        border: 'none', // Remove default outline
      },
    },
  }}>
    <Select
      ref={selectRef}
      style={{
        color: 'white',
        fontFamily: 'Menco, Open Sans, sans-serif',
        fontWeight: '400',
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
        fontSize: '12px',
        backgroundColor: 'transparent',
        border: 'none',
        borderBottom: '1px solid rgba(255, 255, 255, 0.2)',
        borderRadius: '0',
        minHeight: '32px',
        fontSize: '14px',
      }}
      value={value}
      onChange={handleInputChange}
      displayEmpty
      inputProps={{ 'aria-label': 'Without label' }}
      // Remove focus styles completely
      sx={{
        '&.Mui-focused': {
          '& .MuiOutlinedInput-notchedOutline': {
            border: 'none !important',
          },
        },
        '&:focus': {
          outline: 'none !important',
          boxShadow: 'none !important',
        },
      }}
      // Gradient dropdown arrow
      IconComponent={(props) => (
        <div {...props} style={{ 
          background: 'linear-gradient(.25turn, #00C4ED, #00E880)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          fontSize: '12px',
          marginRight: '4px',
          fontWeight: 'bold'
        }}>▼</div>
      )}
      MenuProps={{
        PaperProps: {
          style: {
            backgroundColor: 'rgba(10, 10, 18, 0.92)',
            backdropFilter: 'blur(20px) saturate(1.4)',
            WebkitBackdropFilter: 'blur(20px) saturate(1.4)',
            color: 'rgba(255, 255, 255, 0.85)',
            border: '1px solid rgba(255, 255, 255, 0.08)',
            borderRadius: '12px',
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.4), inset 0 1px 0 rgba(255, 255, 255, 0.04)',
            maxHeight: '200px',
            marginTop: '4px',
          },
        },
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'left',
        },
        transformOrigin: {
          vertical: 'top',
          horizontal: 'left',
        },
      }}
    >
      {dropdownOptions}
    </Select>
  </FormControl>

  const name = props.name.indexOf('?') !== -1 ? props.name : props.name + ':'

  const infoIcon = props.extraInfo !== '' ? 
    (<span className="info-icon"><InfoIcon tooltipMessage={props.extraInfo}/></span>)
    :
    null

  return (
    <div className='form-item'>
      <div style={{ 
        display: 'flex', 
        alignItems: 'center', 
        gap: '10px',
        flexWrap: 'wrap'
      }}>
        <div className='form-label' style={{
          flexShrink: 1
        }}>
          {name} {infoIcon}
        </div>
        <div className='form-item-dropdown' style={{ 
          flex: '1',
          minWidth: '120px'
        }}>
          {input}
        </div>
      </div>
    </div>
  );
}